import React, { useEffect } from 'react';
import { Stack, StackItem, PrimaryButton, Label } from '@fluentui/react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { FnPEditor, fnpEditorConfig } from '../CKEditor/FnPEditorConfig';
import strings from '../../../loc/strings';
import { fetchFieldGuidance, updateFieldGuidance } from '../../../services/AdminServices/FieldGuidanceAdminService';
import { useAuth } from 'react-oidc-context';
import styles from './FieldGuidance.module.css';
import { displayMessageBar } from '../../LayoutWithAuth/LayoutWithAuth';
import { MessageBarType } from '@fluentui/react';

const MAX_GUIDANCE_LENGTH = 1000;

function FieldGuidance() {
    const auth = useAuth();
    const [reasonForRequest, setReasonForRequest] = React.useState('');
    const [infoRequested, setInfoRequested] = React.useState('');

    useEffect(() => {
        fetchFieldGuidance(auth.user?.id_token)
            .then((items) => {
                items.forEach((item) => {
                    if (item.key === 'FieldGuidance_ReasonForRequest') setReasonForRequest(item.value);
                    if (item.key === 'FieldGuidance_InfoRequested') setInfoRequested(item.value);
                });
            })
            .catch((error) => {
                console.error('Error fetching field guidance:', error);
            });
    }, []);

    const handleSave = async () => {
        if (reasonForRequest.length > MAX_GUIDANCE_LENGTH || infoRequested.length > MAX_GUIDANCE_LENGTH) {
            displayMessageBar(MessageBarType.error, `Field guidance cannot exceed ${MAX_GUIDANCE_LENGTH} characters.`, false);
            return;
        }

        try {
            const r1 = await updateFieldGuidance('FieldGuidance_ReasonForRequest', reasonForRequest, auth.user?.id_token);
            const r2 = await updateFieldGuidance('FieldGuidance_InfoRequested', infoRequested, auth.user?.id_token);
            if (r1 && r2) {
                displayMessageBar(MessageBarType.success, 'Field guidance updated successfully.', false);
            } else {
                displayMessageBar(MessageBarType.error, 'Error updating field guidance.', false);
            }
        } catch (error) {
            displayMessageBar(MessageBarType.error, 'Error updating field guidance.', false);
            console.error('Error saving field guidance:', error);
        }
    };

    return (
        <Stack>
            <StackItem className={styles.fieldguidancecontainer}>
                <h2 className={styles.fieldguidanceHeader}>{strings.fieldGuidance}</h2>
                <div className={styles.fieldguidancefields}>
                    <div>
                        <Label>{strings.FieldGuidanceReasonForRequest}</Label>
                        <CKEditor
                            editor={FnPEditor}
                            config={fnpEditorConfig}
                            data={reasonForRequest}
                            onChange={(_event, editor) => setReasonForRequest(editor.getData())}
                        />
                        <span style={{ fontSize: 12, color: reasonForRequest.length > MAX_GUIDANCE_LENGTH ? '#a4262c' : '#605e5c' }}>
                            {reasonForRequest.length} / {MAX_GUIDANCE_LENGTH}
                        </span>
                    </div>
                    <div>
                        <Label>{strings.FieldGuidanceInfoRequested}</Label>
                        <CKEditor
                            editor={FnPEditor}
                            config={fnpEditorConfig}
                            data={infoRequested}
                            onChange={(_event, editor) => setInfoRequested(editor.getData())}
                        />
                        <span style={{ fontSize: 12, color: infoRequested.length > MAX_GUIDANCE_LENGTH ? '#a4262c' : '#605e5c' }}>
                            {infoRequested.length} / {MAX_GUIDANCE_LENGTH}
                        </span>
                    </div>
                </div>
                <div className={styles.fieldguidancebtn}>
                    <PrimaryButton text={strings.ButtonSave} onClick={handleSave} disabled={reasonForRequest.length > MAX_GUIDANCE_LENGTH || infoRequested.length > MAX_GUIDANCE_LENGTH} />
                </div>
            </StackItem>
        </Stack>
    );
}

export default FieldGuidance;
